import type { ISupplier_Type } from '@bridebook/models/source/models/Suppliers.types';
import { z } from 'zod/v4';

/**
 * The supplier categories the planner works with: the shared supplier types without the
 * internal 'group'. The list is local because the app's shared list imports i18n, which
 * breaks the server route bundle.
 */
export type SupplierType = Exclude<ISupplier_Type, 'group'>;

export const PLANNER_SUPPLIER_TYPES: SupplierType[] = [
  'venue',
  'photo',
  'video',
  'florist',
  'music',
  'beauty',
  'cakes',
  'catering',
  'decoration',
  'dress',
  'entertainment',
  'jewellery',
  'marquee',
  'menswear',
  'planners',
  'stationery',
  'transport',
];

export const SupplierTypeEnum = z.enum(PLANNER_SUPPLIER_TYPES as [SupplierType, ...SupplierType[]]);
